// removed by extract-text-webpack-plugin
module.exports = {"container":"bI1m","wrapper":"_15jJ","services":"BlVg","reveal":"_1zAl","title":"_3X3C","primaryColor":"_3qKC","serviceContainer":"_2ft8","imageContainer":"_303F","serviceIcon":"_2CLX","serviceTitle":"_2Sbd","serviceText":"_2G55"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/LandingPage/Services/styles.scss
// module id = 405
// module chunks = 0